import {useMemo} from "react"
import {useTranslation} from "react-i18next";
import {ChallengeMode} from "../../schema";

export default function useChallengeModeTranslation(challengeMode: ChallengeMode) {
  const {t} = useTranslation();

  return useMemo(() => {
    switch (challengeMode) {
      case ChallengeMode.COMPETENCE_TEST:
        return t("types.ChallengeMode.COMPETENCE_TEST")
      case ChallengeMode.CHOICE_BASED_STUDY:
        return t("types.ChallengeMode.CHOICE_BASED_STUDY")
      case ChallengeMode.CHOICES_WITH_CUSTOM_SCORES:
        return t("types.ChallengeMode.CHOICES_WITH_CUSTOM_SCORES")
      case ChallengeMode.CUSTOM_PARAMETERS_TEST:
        return t("types.ChallengeMode.CUSTOM_PARAMETERS_TEST")
      case ChallengeMode.RPG_MODE:
        return t("types.ChallengeMode.RPG_MODE")
      default:
        throw new Error(`Not supported challenge mode for translation: "${challengeMode}"`)
    }
  }, [challengeMode, t])
}
